import { TRPCClientError } from "@trpc/client";
import { AppointmentErrorType } from "@remi/error";
import { isOneOf } from "@remi/ts-utils";

const PRECHECK_ERROR_TYPES = [
  AppointmentErrorType.APPOINTMENT_SLOT_UNAVAILABLE,
  AppointmentErrorType.APPOINTMENT_SLOT_OFF_GRID,
  AppointmentErrorType.APPOINTMENT_SLOT_OUTSIDE_WORKING_HOURS,
  AppointmentErrorType.NOT_A_FIELD_SALES_REP,
  AppointmentErrorType.FREEBUSY_CALENDAR_ERROR,
] as const;

export const getAppointmentPrecheckMessage = (error: unknown): string | undefined =>
  error instanceof TRPCClientError && isOneOf(error.data?.errorType, PRECHECK_ERROR_TYPES) ? error.message : undefined;
